import axios from "axios"
import queryString from "query-string"

const baseURL = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v2`

const privateClient = axios.create({
  baseURL,
  paramsSerializer: {
    encode: params => queryString.stringify(params)
  }
})

privateClient.interceptors.request.use(async config => {
  const isFormData = config.data instanceof FormData
  const existingHeaders = config.headers || {}

  const headers = {
    ...existingHeaders,
    "Authorization": `Bearer ${localStorage.getItem("actkn")}`
  }

  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }

  return {
    ...config,
    headers
  }
})

privateClient.interceptors.response.use((response) => {
  if (response && response.data) return response.data
  return response
}, (err) => {
  throw err.response.data
})

export default privateClient
